import React from 'react';
import { useSelector } from 'react-redux';
import steps from '../../survey/stepsV2';
import ProgressBarV2 from '../progressBarV2';
import ProgressBarV3 from '../progressBarV3';
import s from './index.module.scss';
import getParameterFromURL from '../../utils/scripts/getParameterFromURL';

const HIDE_HEADER_STEPS = new Set([
  'customV2_startPage', 'customV2_policyPage', 'customV2_policyPageV2', 'customV2_policyPageV4', 'customV2_policyPageV5', 'customV2_policyPageV6', 'customV2_info_health', 'customV2_info_breed', 'customV2_info_breed_2',
  'customV2_info_breed_3', 'customV2_videoPolicyPage', 'customV2_start_page_video', 'customV2_startPageV2',
  'customV2_startPageV3', 'customV2_startPageV4', 'customV2_startPageV5', 'customV2_startPageV11',
  'customV2_info_predict', 'customV2_start_page_video_v2', 'info_thank', 'info_about_owner',
  'info_about_potty', 'customV2_startPageV6', 'customV2_startPageV7', 'customV2_startPageV8',
  'customV2_startPageGender', 'customV2_specialOffer', 'customV2_startPageV17', 'customV2_startPageV18', 'customV2_startPageV19', 'customV2_startPageV20', 'customV2_startPageV21', 'customV2_startPageV22', 'customV2_policyPageV3', 'customV2_startPageV23', 'info_about_crate', 'customV2_startPageV24', 'info_about_potty_struggles', 'info_about_training', 'customV2_startPageV25', 'customV2_startPageV26', 'customV2_startPageV27', 'customV2_startPageV28', 'customV2_startPageV29', 'customV2_startPageV30', 'info_about_understanding', 'understanding_summary', 'customV2_startPageV31', 'customV2_startPageV34', 'behavior_signals', 'info_about_worries', 'customV2_startPageV37', 'customV2_startPageV44',
]);

const HIDE_PROGRESS_STEPS = new Set([
  'customV2_info_health', 'customV2_info_breed_2', 'customV2_info_breed_3', 'customV2_creating_program', 'customV2_email',
  'customV2_plan', 'customV4_behavior_problem', 'customV2_age_v2', 'customV5_behavior_problem',
  'receive_email', 'customV2_specialOffer', 'customV2_age_v3', 'customV2_age_v4', 'customV2_age_v5', 'start_page_age', 'customV2_specialOffer_v2', 'start_page_age_v2', 'training_time', 'info_about_crate', 'info_about_potty_struggles', 'customV2_specialOffer_v3', 'start_page_age_v3', 'understanding_summary', 'behavior_signals',
]);

const cx = (...args) => args.filter(Boolean).join(' ');

const HEADER_VARIANTS = {
  noBorder: new Set(['start_page_age', 'start_page_age_v2', 'training_time', 'customV2_specialOffer_v3', 'start_page_age_v3']),
};

const TRAINING_TIME_SKIP_BACK_CONFIGS = new Set([
  'customV2',
  'customV18',
  'customV28',
  'customV38',
  'customV40',
  'customV41',
  'customV49',
  'customV72',
]);

function HeaderV2() {
  const currentStep = useSelector((state) => state.steps.currentStep);
  const configFromState = useSelector((state) => state.steps.config);
  const questions = useSelector((state) => state.questions.list);

  const urlConfig = getParameterFromURL('config');
  const everydoggyV5 = getParameterFromURL('everydoggyV5') === 'true';
  const tariff = getParameterFromURL('tariff') || null;

  const isCustomV17 = urlConfig === 'customV17';
  const p10FirstScreensZw = false;

  const showHeader = !HIDE_HEADER_STEPS.has(currentStep);
  const showProgress = !HIDE_PROGRESS_STEPS.has(currentStep);

  const BASE_STEPS_WITHOUT_BACK = new Set([
    'customV2_creating_program', 'customV2_email', 'customV2_plan', 'customV3_gender',
    'customV2_age_v3', 'customV4_behavior_problem', 'customV5_behavior_problem',
    'customV2_age_v2', 'receive_email', 'gender_zw', 'customV2_age_v4', 'customV2_age_v5', 'start_page_age', 'customV2_specialOffer_v2', 'start_page_age_v2', 'training_time', 'customV2_specialOffer_v3', 'start_page_age_v3',
  ]);

  const isGenderNoBackForCustomV13 = urlConfig === 'customV13' && currentStep === 'customV2_gender';
  const isGenderNoBackForCustomV2V5 = urlConfig === 'customV2' && everydoggyV5 && !tariff && currentStep === 'customV2_gender';

  const removeBackButton = BASE_STEPS_WITHOUT_BACK.has(currentStep)
    || isGenderNoBackForCustomV13
    || isGenderNoBackForCustomV2V5;

  const headerClassName = cx(
    s.header,
    HEADER_VARIANTS.noBorder.has(currentStep) && s.header_noBorder,
  );

  function goBack() {
    try {
      const isTrainingTime = currentStep === 'customV2_training_time'
        && TRAINING_TIME_SKIP_BACK_CONFIGS.has(configFromState);

      if (isTrainingTime) {
        const reasonAnswers = Object.values(questions?.customV2_reason?.answers || {});
        const dateAnswers = Object.values(questions?.customV2_date?.answers || {});
        const reasonIndex = reasonAnswers[0]?.index;

        if (reasonAnswers.length === 0 || reasonIndex === 'v8') {
          steps.navigate.back({ numberOfSteps: 3 });
        } else if (dateAnswers.length === 0) {
          steps.navigate.back({ numberOfSteps: 2 });
        } else {
          steps.navigate.back();
        }
      } else {
        steps.navigate.back();
      }

      steps.userMovedToPreviousStepByClick();
    } catch (error) {
      console.error('Error goBack:', error);
    }
  }

  if (!showHeader) return null;

  return (
    <div className={s.headerWrapper}>
      <div className={headerClassName}>
        {!removeBackButton && (
          <button
            type="button"
            className={s.backButton}
            onClick={goBack}
            aria-label="Назад"
          />
        )}
        {p10FirstScreensZw ? <div className={s.logoV2} /> : <div className={s.logo} />}
      </div>

      {showProgress && (isCustomV17 ? <ProgressBarV3 /> : <ProgressBarV2 />)}
    </div>
  );
}

export default HeaderV2;
